import { styled } from '../../../../../utils/styled';
import { propStyles } from '../../../../../utils/propStyles';

const StyledComponent = styled<any, any>(
    'section',
    'toasterWrapper',
    'feedback-toaster'
)`
    ${propStyles};
    bottom: 0;
`;

StyledComponent.defaultProps = {
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    right: '0',
    padding: '4px',
    zIndex: '10',
    height: 'auto',
    width: '100%',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toaster/StyledComponents/ToasterWrapper.tsx